import React, { useEffect, useState } from "react";
import styles from "../styles/pujaSearch.module.css";
// import Mandala from "@public/assets/icons/mandala.svg";
import SearchIcon from "@mui/icons-material/Search";
import { getAllCommunityEvents, getSearchedCommunityEvent } from "../queries/pujas.queries";
import { useTranslation } from "react-i18next";
import dynamic from "next/dynamic";
import { Box, CircularProgress, TextField } from "@mui/material";
import { useDebouncedCallback } from "use-debounce";
const Mandala = dynamic(() => import("@public/assets/icons/mandala.svg"));
const SearchBox = ({
  setPujasState,
  setHasMorePujas,
  search,
  setSearch,
  pujaPage,
  setPujaPage,
  setLoading,
  loading
}) => {
  //const [search, setSearch] = useState("");
  //const [pujaPage, setPujaPage] = useState(0);
  const {
    t
  } = useTranslation();
  const [debouncedSearch, setDebouncedSearch] = useState(search);
  const [isFocused, setIsFocused] = useState(false);
  // const [hasMorePujas, setHasMorePujas] = useState(true);

  // Debounce callback
  const debounced = useDebouncedCallback(
  // function
  value => {
    setDebouncedSearch(value);
  },
  // delay in ms
  500);
  useEffect(() => {
    async function getData() {
      const obj = {
        search: debouncedSearch,
        page: pujaPage
      };
      const response = await getSearchedCommunityEvent(obj);
      if (response.data?.length === 0) {
        // setPujasState([]);
        setPujaPage(0);
        setHasMorePujas(false);
      } else {
        setPujasState(response.data);
        setPujaPage(cur => cur + 1);
        setHasMorePujas(true);
      }
      setLoading(false);
    }
    if (debouncedSearch.length > 0) {
      setLoading(true);
      getData();
      setPujaPage(0);
    }
    if (debouncedSearch.length === 0 && isFocused) {
      getInitialData();
    }
  }, [debouncedSearch, setHasMorePujas]);
  async function getInitialData() {
    let response = null;
    if (search === "" || search === null) {
      //console.log("searchObj 1", searchObj);
      response = await getAllCommunityEvents({
        page: 0
      });
    }
    if (!response.err && response.data) {
      if (response.data.length === 0) {
        setHasMorePujas(false);
      } else {
        setPujasState(response.data);
        setPujaPage(0);
        setHasMorePujas(true);
      }
    } else {
      setHasMorePujas(false);
    }
  }

  // async function updateData() {
  //   const obj = {
  //     search: search,
  //     page: pujaPage,
  //   };
  //   const response = await getSearchedCommunityEvent(obj);

  //   if (!response.err && response.data) {
  //     if (response.data.length === 0) {
  //       setHasMorePujas(false);
  //     } else {
  //       setPujasState((currentData) => [...currentData, ...response.data]);
  //       setPujaPage((cur) => cur + 1);
  //       setHasMorePujas(true);
  //     }
  //   } else {
  //     setHasMorePujas(false);
  //   }
  // }

  function setSearchValue(data) {
    setSearch(data);
    // setSearchData(data);
    setPujaPage(0);
    setHasMorePujas(true);
  }
  return <div className={styles.searchHeaderContainer} data-sentry-component="SearchBox" data-sentry-source-file="pujaSearchBox.jsx">
      <div className={styles.searchHeader}>
        <div className={styles.leftMandalaDiv}>
          <div className={styles.leftMandala}>
            <Mandala data-sentry-element="Mandala" data-sentry-source-file="pujaSearchBox.jsx" />
          </div>
        </div>
        <div className={styles.rightMandalaDiv}>
          <div className={styles.rightMandala}>
            <Mandala data-sentry-element="Mandala" data-sentry-source-file="pujaSearchBox.jsx" />
          </div>
        </div>
        <div className={styles.searchInner}>
          <div className={styles.communityHeading}>
            {t("explore")} <span>{t("upcoming")}</span> {t("pujas")}
          </div>

          <TextField id="outlined-basic" placeholder={`${t("search-for")} ${t("bankey-bihari-puja")}`}
        // label="Outlined"
        variant="outlined" fullWidth InputProps={{
          startAdornment: <SearchIcon />,
          endAdornment: <Box sx={{
            display: "flex",
            justifyContent: "center"
            // size: 50,
          }}>
                  {loading && <CircularProgress size={20} sx={{
              color: "#ff9800"
            }} />}
                </Box>
        }} sx={{
          "& .MuiOutlinedInput-root": {
            borderRadius: "28px",
            // Rounded corners
            backgroundColor: "white",
            // White background
            height: "45px",
            // Fixed height
            border: "1px solid #fcfafa" // Border with the specified color
          },
          "& .MuiOutlinedInput-notchedOutline": {
            borderColor: "#fcfafa" // Outline color when focused
          },
          "&:hover .MuiOutlinedInput-notchedOutline": {
            borderColor: "#fcfafa" // Outline color on hover
          },
          "& .MuiInputBase-input": {
            padding: "10px" // Adjust padding to align the text properly within the height
          }
        }} value={search} onChange={e => {
          debounced(e.target.value);
          setSearchValue(e.target.value);
        }} onFocus={() => setIsFocused(true)} data-sentry-element="TextField" data-sentry-source-file="pujaSearchBox.jsx" />
          {/* <div className={styles.searchBox}>
            <span className={styles.searchIcon}>
              <SearchIcon />
            </span>
            <input
              type="text"
              placeholder={`${t("search-for")} ${t("bankey-bihari-puja")}`}
              className={styles.searchInput}
              value={search}
              onChange={(e) => {
                debounced(e.target.value);
                setSearchValue(e.target.value);
              }}
              onFocus={() => setIsFocused(true)}
            />
            {loading && (
              <CircularProgress size={20} sx={{ color: "#ff9800" }} />
            )}
           </div> */}

          <div className={styles.popularSearchContainer}>
            <div className={styles.popularSearch}>{t("popular-searches")}</div>
            <div className={styles.searchSuggestion} onClick={() => {
            debounced(t("bankey-bihari"));
            setSearchValue(t("bankey-bihari"));
          }}>
              {t("bankey-bihari")}
            </div>
            <div className={styles.searchSuggestion} onClick={() => {
            debounced(t("kashi"));
            setSearchValue(t("kashi"));
          }}>
              {t("kashi")}
            </div>
            <div className={styles.searchSuggestion} onClick={() => {
            debounced(t("mangalnath"));
            setSearchValue(t("mangalnath"));
          }}>
              {t("mangalnath")}
            </div>
          </div>
        </div>
      </div>
    </div>;
};
export default SearchBox;